import { apiRequest } from '../../../../shared/http/transport.js';
export const fetchContext = ({ dateKey, time, signal }) => apiRequest({ path: `/api/reminders/context/${dateKey}`, query: { time }, signal });
export const saveSettings = (body) => apiRequest({ path: '/api/reminders/settings', method: 'PUT', body });
export const saveAction = ({ occurrenceKey, ...body }) => apiRequest({ path: `/api/reminders/occurrences/${encodeURIComponent(occurrenceKey)}`, method: 'PUT', body });
export const fetchAudit = ({ cursor, limit = 20, signal } = {}) => apiRequest({ path: '/api/reminders/audit', query: { cursor, limit }, signal });

